<template>
  <section
    class="rev-ras-hero-module-component"
    :class="{
      'left-bottom': data.left_bottom_rounded,
    }"
    :style="{
      backgroundColor: !data.left_bottom_rounded
        ? data.background_color
        : '#0E4343',
    }">
    <div
      :style="{
        backgroundColor: data.left_bottom_rounded
          ? data.background_color
          : 'transparent',
      }"
      class="rounding"></div>
    <img
      v-if="data.enable_background_image"
      class="background-image"
      src="@/assets/img/rev_ras_bg_top.svg"
      alt="Revmed Logo" />
    <div class="hero-top">
      <div class="rr-container">
        <img
          v-if="data.add_image"
          ref="heroImageRef"
          :src="data.image.url"
          :alt="data.image.alt"
          class="hero-image" />

        <div
          ref="heroTextRef"
          class="hero-text">
          <div
            class="hero-title"
            v-html="props.data.hero_text" />

          <div
            v-if="data.add_hero_subtitle"
            class="subtitle"
            v-html="data.hero_subtitle"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
 {
  "NAME": "RevRasHeroComponent",
  "CLASSNAME": "rev-ras-hero-module-component",
  "URL": "http://vuevitewp.local/test"
 }
#ENDMETA */

/*
 * Insert your logic here
 */

import { onMounted, ref } from 'vue'
import { gsap } from 'gsap'

const props = defineProps(['data'])
const heroTextRef = ref(null)
const heroImageRef = ref(null)

console.log('RevRasHeroComponent props:', props.data)

onMounted(() => {
  gsap.set(heroTextRef.value, {
    y: 20,
    opacity: 0,
  })

  gsap.set(heroImageRef.value, {
    y: -20,
    opacity: 0,
  })

  const animateText = () => {
    if (!heroTextRef.value) return

    if (props.data.add_image && heroImageRef.value) {
      gsap.to(heroImageRef.value, {
        y: 0,
        opacity: 1,
        ease: 'Power4.easeOut',
      })
    }

    gsap.to(heroTextRef.value, {
      y: 0,
      opacity: 1,
      duration: 1.2,
      delay: heroImageRef.value ? 0.2 : 0,
      ease: 'Power4.easeOut',
    })
  }

  animateText()
})
</script>

<style lang="scss" scoped>
.rev-ras-hero-module-component {
  @apply block relative z-0;

  @apply relative min-h-[314px] pt-[150px] pb-[80px] flex flex-col justify-start
    md:pt-[210px] md:min-h-[374px] lg:min-h-[481px] z-1 lg:pb-[60px];

  .background-image {
    @apply pointer-events-none absolute hidden top-0 right-[-85px] w-[832px] h-full z-[-1] object-cover object-bottom lg:block;
  }

  .rounding {
    @apply absolute top-0 left-0 w-full h-full z-[-1] bg-humble;
    content: '';
    @apply rounded-br-[50px] md:rounded-br-[60px] lg:rounded-br-[80px];
  }

  &.left-bottom {
    .rounding {
      @apply rounded-br-[0px] bottom-[-1px] top-auto z-0;
      @apply h-[50px] rounded-tl-[50px] md:h-[60px] md:rounded-tl-[60px] lg:h-[80px] lg:rounded-tl-[80px];
    }
  }

  .hero-top {
    @apply relative;

    .rr-container {
      @apply relative flex flex-col gap-8 lg:gap-10;

      .hero-image {
        @apply object-contain max-w-[230px] lg:max-w-[420px] h-auto ml-0;
      }

      .hero-text {
        @apply relative
    md:max-w-[490px]
    lg:pb-10 lg:max-w-[880px];

        .hero-title {
          &:deep(h1) {
            @apply text-white font-FKDisplayALT text-[32px] leading-[1] tracking-[-0.8px]
        lg:text-[80px] lg:not-italic lg:font-normal lg:tracking-[-1.2px];

            strong {
              @apply font-normal text-progressive;
            }
          }
        }

        .subtitle {
          @apply pt-5;

          :deep(p) {
            @apply text-[16px] leading-tight text-white lg:text-[22px];
          }
        }

        .bicolor-line-container {
          @apply relative overflow-hidden w-full;
        }

        .bicolor-line {
          @apply mt-6 h-[4px] w-[120px]
      lg:mt-6 lg:h-[5px] lg:w-[220px];
        }
      }
    }
  }
}
</style>
